var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.extras1 && _vm.extras1.formBgWap)?_c('div',{staticClass:"banner-new",style:({
    background:
      _vm.extras1.formBgWap && _vm.extras1.formBgWap.colorOrBg == 'color'
        ? _vm.extras.formBgWap.color
        : '',
  })},[_c('img',{attrs:{"src":_vm.extras1.formBgWap && _vm.extras1.formBgWap.colorOrBg == 'src'
        ? _vm.extras.formBgWap.src
        : '',"alt":""}}),(_vm.isSetting != 1)?_c('div',[_c('div',{staticClass:"seminar-info"},[_c('div',{staticClass:"seminar-info-new wap",class:_vm.extras1.BannerText && _vm.extras1.BannerText.textAlign},[_c('div',{staticClass:"content"},[(
              _vm.extras1.textSetting && _vm.extras1.textSetting.subTitle != 'hide'
            )?_c('div',{staticClass:"seminar-title",style:({
              color:
                _vm.extras1.textSetting.subTitle == 'custom'
                  ? _vm.extras1.textSetting.subTitleFontColor
                  : '',

              'font-weight':
                _vm.extras1.textSetting.subTitle == 'custom'
                  ? _vm.extras1.textSetting.subTitleFontWeight == 'on'
                    ? '900'
                    : ''
                  : '',
              'font-style':
                _vm.extras1.textSetting.subTitle == 'custom'
                  ? _vm.extras1.textSetting.subTitleFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
            })},[_vm._v(" "+_vm._s(_vm.extras1.textSetting && _vm.extras1.textSetting.text)+" ")]):_vm._e(),(_vm.extras1.textSetting && _vm.extras1.textSetting.title != 'hide')?_c('div',{staticClass:"seminar-slogan",style:({
              color:
                _vm.extras1.textSetting.title == 'custom'
                  ? _vm.extras1.textSetting.titleFontColor
                  : '',

              'font-weight':
                _vm.extras1.textSetting.title == 'custom'
                  ? _vm.extras1.textSetting.titleFontWeight == 'on'
                    ? '900'
                    : ''
                  : '',
              'font-style':
                _vm.extras1.textSetting.title == 'custom'
                  ? _vm.extras1.textSetting.titleFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
            })},[_vm._v(" "+_vm._s(_vm.extras1.textSetting && _vm.extras1.textSetting.title == "default" ? _vm.seminarInfo.title : _vm.seminarInfo.title)+" ")]):_vm._e(),_c('div',{staticClass:"semianr-time"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                _vm.extras1.textSetting && _vm.extras1.textSetting.timeTitle != 'hide'
              ),expression:"\n                extras1.textSetting && extras1.textSetting.timeTitle != 'hide'\n              "}],staticClass:"_title",style:({
                color:
                  _vm.extras1.textSetting.timeTitle == 'custom'
                    ? _vm.extras1.textSetting.timeTitleFontColor
                    : '',

                'font-weight':
                  _vm.extras1.textSetting.timeTitle == 'custom'
                    ? _vm.extras1.textSetting.timeTitleFontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
                'font-style':
                  _vm.extras1.textSetting.timeTitle == 'custom'
                    ? _vm.extras1.textSetting.timeTitleFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'background-color':
                  _vm.extras1.textSetting && _vm.extras1.textSetting.titleBgColor
                    ? _vm.extras1.textSetting.titleBgColor
                    : 'transparent',
              })},[_vm._v(" "+_vm._s(_vm.getTimeTitleText())+" ")]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
                _vm.extras1.textSetting && _vm.extras1.textSetting.time != 'hide'
              ),expression:"\n                extras1.textSetting && extras1.textSetting.time != 'hide'\n              "}],staticClass:"_time",style:({
                color:
                  _vm.extras1.textSetting.time == 'custom'
                    ? _vm.extras1.textSetting.timeFontColor
                    : '',

                'font-weight':
                  _vm.extras1.textSetting.time == 'custom'
                    ? _vm.extras1.textSetting.timeFontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
                'font-style':
                  _vm.extras1.textSetting.time == 'custom'
                    ? _vm.extras1.textSetting.timeFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'background-color':
                  _vm.extras1.textSetting && _vm.extras1.textSetting.timeBgColor
                    ? _vm.extras1.textSetting.timeBgColor
                    : 'transparent',
              })},[_vm._v(" "+_vm._s(_vm.handleTimeStamps(_vm.seminarInfo.startTime, _vm.seminarInfo.endTime))+" ")])])])])])]):_vm._e(),(_vm.isSetting == 1)?_c('div',[(
        _vm.extras1 && _vm.extras1.seminarInfo && _vm.extras1.seminarInfo.display == '1'
      )?_c('div',{staticClass:"seminar-info"},[_vm._m(0)]):_vm._e()]):_vm._e()]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"seminar-info-new wap _left"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"seminar-title"},[_vm._v("会议副标题会议副标题")]),_c('div',{staticClass:"seminar-slogan"},[_vm._v("会议标会议标题")]),_c('div',{staticClass:"semianr-time"},[_c('div',{staticClass:"_title"},[_vm._v("会议时间")]),_c('div',{staticClass:"_time"},[_vm._v("2023-12-12 12:22-24:00")])])])])}]

export { render, staticRenderFns }